// Language switching is handled natively by Shopify's {% form 'localization' %}
// submit. The theme no longer intercepts it, so switching language changes the
// real request locale and the URL prefix instead of only swapping text.
document.addEventListener('click', (event) => {
  const kayanMenuButton = event.target.closest('.kayan-menu[aria-controls="KayanMenuModal"]');
  if (kayanMenuButton) {
    event.preventDefault();
    const modal = document.getElementById('KayanMenuModal');
    if (modal) {
      modal.hidden = false;
      kayanMenuButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('kayan-menu-open');
      modal.querySelector('.kayan-menu-product')?.focus();
    }
    return;
  }

  const kayanMenuClose = event.target.closest('.kayan-menu-close, .kayan-menu-modal__backdrop');
  if (kayanMenuClose) {
    event.preventDefault();
    closeKayanMenu();
    return;
  }

  const kayanVariantOption = event.target.closest('.kayan-format-option[data-variant-id]');
  if (kayanVariantOption) {
    event.preventDefault();
    selectKayanVariant(kayanVariantOption);
    return;
  }

  const thumb = event.target.closest('.casa-mobile-thumbs button');
  if (thumb) {
    const index = Array.from(thumb.parentElement.children).indexOf(thumb);
    const gallery = document.querySelector('.casa-media-grid');
    const card = gallery?.children[index];
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  const kayanThumb = event.target.closest('.kayan-product-thumbs button');
  if (kayanThumb) {
    const index = Array.from(kayanThumb.parentElement.children).indexOf(kayanThumb);
    const gallery = document.querySelector('.kayan-product-gallery');
    const card = gallery?.children[index];
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }
});

document.addEventListener('submit', (event) => {
  if (event.target.matches('.atelier-newsletter, .kayan-newsletter')) {
    event.preventDefault();
  }

  const kayanBuyForm = event.target.closest('.kayan-buy-form');
  if (kayanBuyForm) {
    event.preventDefault();
    addKayanProductToCart(kayanBuyForm);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeKayanMenu();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  initKayanIngredientCarousels();
});

function initKayanIngredientCarousels() {
  document.querySelectorAll('[data-kayan-ingredient-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('.kayan-ingredient-track');
    const originalCards = Array.from(track?.querySelectorAll('.kayan-ingredient-card') || []);
    const progress = carousel.querySelector('[data-kayan-carousel-progress]');
    const progressBar = carousel.querySelector('[data-kayan-carousel-bar]');
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    const reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!track || originalCards.length < 2) {
      return;
    }

    let index = 0;
    let intervalId;
    let resetId;
    let loopClone;
    let isVisible = !('IntersectionObserver' in window);

    const stop = () => {
      window.clearInterval(intervalId);
      window.clearTimeout(resetId);
      intervalId = undefined;
      resetId = undefined;
    };

    const getStep = () => {
      const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return originalCards[0].getBoundingClientRect().width + gap;
    };

    const updateProgress = () => {
      const visibleIndex = index % originalCards.length;
      if (progress) {
        progress.textContent = `${String(visibleIndex + 1).padStart(2, '0')} / ${String(originalCards.length).padStart(2, '0')}`;
      }
      if (progressBar) {
        progressBar.style.width = `${((visibleIndex + 1) / originalCards.length) * 100}%`;
      }
    };

    const updatePosition = ({ animate = true } = {}) => {
      if (!animate) {
        track.style.transition = 'none';
      }
      track.style.transform = `translate3d(${-index * getStep()}px, 0, 0)`;
      updateProgress();
      if (!animate) {
        window.requestAnimationFrame(() => track.style.removeProperty('transition'));
      }
    };

    const advance = () => {
      index += 1;
      updatePosition();
      if (index === originalCards.length) {
        resetId = window.setTimeout(() => {
          index = 0;
          updatePosition({ animate: false });
        }, 600);
      }
    };

    const start = () => {
      stop();
      if (!mobileMedia.matches || reducedMotionMedia.matches || !isVisible || document.hidden) {
        return;
      }
      intervalId = window.setInterval(advance, 1800);
    };

    const setup = () => {
      stop();
      loopClone?.remove();
      loopClone = undefined;
      index = 0;
      track.style.removeProperty('transform');
      track.style.removeProperty('transition');

      if (!mobileMedia.matches || reducedMotionMedia.matches) {
        updateProgress();
        return;
      }

      loopClone = originalCards[0].cloneNode(true);
      loopClone.setAttribute('aria-hidden', 'true');
      loopClone.setAttribute('data-kayan-carousel-clone', '');
      track.appendChild(loopClone);
      updatePosition({ animate: false });
      start();
    };

    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver(([entry]) => {
          isVisible = entry.isIntersecting;
          start();
        }, { threshold: 0.2 })
      : null;

    observer?.observe(carousel);
    mobileMedia.addEventListener('change', setup);
    reducedMotionMedia.addEventListener('change', setup);
    window.addEventListener('resize', () => {
      if (mobileMedia.matches && !reducedMotionMedia.matches) {
        updatePosition({ animate: false });
      }
    });
    document.addEventListener('visibilitychange', start);
    setup();
  });
}

function closeKayanMenu() {
  const modal = document.getElementById('KayanMenuModal');
  if (!modal || modal.hidden) {
    return;
  }

  modal.hidden = true;
  document.body.classList.remove('kayan-menu-open');
  const menuButton = document.querySelector('.kayan-menu[aria-controls="KayanMenuModal"]');
  menuButton?.setAttribute('aria-expanded', 'false');
  menuButton?.focus();
}

async function addKayanProductToCart(form) {
  const button = form.querySelector('.kayan-main-atc');
  if (button?.disabled) {
    return;
  }

  const originalLabel = button?.querySelector('[data-kayan-atc-label]')?.textContent;
  button?.setAttribute('disabled', 'disabled');
  button?.classList.add('is-loading');
  const label = button?.querySelector('[data-kayan-atc-label]');
  // Labels come from the rendered markup, which is already translated.
  if (label && button?.dataset.kayanAddingLabel) {
    label.textContent = button.dataset.kayanAddingLabel;
  }

  // Cart routes are injected by layout/theme.liquid and carry the locale prefix.
  const routes = window.kayanRoutes || {};
  const cartAddUrl = `${routes.cartAdd || '/cart/add'}.js`;
  const cartUrl = routes.cart || '/cart';

  try {
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });

    if (!response.ok) {
      throw new Error('Cart add failed');
    }

    window.location.href = cartUrl;
  } catch (error) {
    if (label && originalLabel) {
      label.textContent = originalLabel;
    }
    button?.removeAttribute('disabled');
    button?.classList.remove('is-loading');
    form.submit();
  }
}

function selectKayanVariant(option) {
  const form = document.querySelector('.kayan-buy-form');
  const variantInput = form?.querySelector('input[name="id"]');
  const atcButton = form?.querySelector('.kayan-main-atc');
  const priceLabel = atcButton?.querySelector('[data-kayan-atc-price]');
  const actionLabel = atcButton?.querySelector('[data-kayan-atc-label]');
  const isAvailable = option.dataset.variantAvailable === 'true';

  if (variantInput) {
    variantInput.value = option.dataset.variantId;
  }

  if (priceLabel && option.dataset.variantId) {
    priceLabel.querySelectorAll('[data-kayan-price-for]').forEach((el) => {
      el.hidden = el.dataset.kayanPriceFor !== option.dataset.variantId;
    });
  }

  document.querySelectorAll('.kayan-format-option[data-variant-id]').forEach((button) => {
    button.classList.toggle('is-active', button === option);
  });

  // Le compteur de stock suit la variante sélectionnée, comme le prix.
  document.querySelectorAll('[data-kayan-stock-for]').forEach((el) => {
    el.hidden = el.dataset.kayanStockFor !== option.dataset.variantId;
  });

  if (atcButton) {
    atcButton.toggleAttribute('disabled', !isAvailable);
  }

  // Both labels are rendered translated by the section and read from the DOM,
  // so no copy is duplicated in JavaScript.
  if (actionLabel && atcButton) {
    const { kayanCtaLabel, kayanSoldoutLabel } = atcButton.dataset;
    const nextLabel = isAvailable ? kayanCtaLabel : kayanSoldoutLabel;
    if (nextLabel) {
      actionLabel.textContent = nextLabel;
    }
  }
}
